import SponsorshipInfoModalComponent from "./SponsorshipInfoModalComponent";

export default SponsorshipInfoModalComponent;
